import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Switch,
  TextField,
  Typography,
} from '@mui/material';

export const ChatSettingsDialog = ({
  open,
  onClose,
  debugMode,
  onDebugModeChange,
  systemPrompt,
  loadingPrompt,
  promptError,
}) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
    <DialogTitle>Chat Settings</DialogTitle>
    <DialogContent dividers>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Box>
          <FormControlLabel
            control={
              <Switch
                checked={debugMode}
                onChange={(event) => onDebugModeChange(event.target.checked)}
              />
            }
            label="Enable debug diagnostics in responses"
          />
          <Typography variant="body2" color="text.secondary">
            When enabled, the assistant will append tool usage and timing details to each reply.
            Debug output is only available to admins and is shared with this session&apos;s messages.
          </Typography>
        </Box>

        <Box>
          <Typography variant="subtitle1" gutterBottom>
            Active System Prompt
          </Typography>
          {promptError ? (
            <Typography variant="body2" color="error">
              {promptError}
            </Typography>
          ) : (
            <TextField
              value={loadingPrompt ? 'Loading system prompt…' : systemPrompt || 'No prompt available'}
              multiline
              fullWidth
              minRows={10}
              InputProps={{
                readOnly: true,
                sx: { fontFamily: 'monospace', fontSize: '0.75rem' },
              }}
            />
          )}
        </Box>
      </Box>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
);

ChatSettingsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  debugMode: PropTypes.bool.isRequired,
  onDebugModeChange: PropTypes.func.isRequired,
  systemPrompt: PropTypes.string,
  loadingPrompt: PropTypes.bool,
  promptError: PropTypes.string,
};

ChatSettingsDialog.defaultProps = {
  systemPrompt: '',
  loadingPrompt: false,
  promptError: '',
};

export default ChatSettingsDialog;
